import 'globals';

(function($, window, document, pageLoadedQueue) {
    pageLoadedQueue.push(function() {
        var createMessage = function (status, message) {
                iziToast.show({
                    class: 'iziToast-' + status,
                    animateInside: false,
                    progressBar: false,
                    timeout: 3200,
                    transitionIn: 'fadeInLeft',
                    transitionInMobile: 'fadeIn',
                    transitionOutMobile: 'fadeOut',
                    message: message,
                    position: 'topRight'
                });
            },
            updateNotification = function (count) {
                document.querySelector('.tool-notification .badge').innerHTML = count;
            },
            updateText = function (subscribed) {
                var aboText = document.querySelectorAll('.abo-toggle .btn-action__text, .abo-action .btn-action__text');
                if (subscribed) {
                    Array.prototype.forEach.call(aboText, function(el) {
                        el.innerHTML = _AVENCY_BASE_translations.documents.abo.subscribed;
                    });
                } else {
                    Array.prototype.forEach.call(aboText, function(el) {
                        el.innerHTML = _AVENCY_BASE_translations.documents.abo.unsubscribed;
                    });
                }
            },
            updateClasses = function(subscribed) {
                if (subscribed) {
                    document.querySelector('.abo-toggle').classList.add('subscribed');
                    document.querySelector('.abo-toggle').classList.remove('not-subscribed');
                    document.querySelector('.abo-action').classList.add('subscribed');
                    document.querySelector('.abo-action').classList.remove('not-subscribed');
                } else {
                    document.querySelector('.abo-toggle').classList.add('not-subscribed');
                    document.querySelector('.abo-toggle').classList.remove('subscribed');
                    document.querySelector('.abo-action').classList.add('not-subscribed');
                    document.querySelector('.abo-action').classList.remove('subscribed');
                }
            }
        ;

        $('.abo-toggle').on('click', function() {
            $('#abo-toggle').slideToggle();
        });
        $('.abo-action').on('click', function() {
            var me = $(this);
            if (me.hasClass('not-subscribed')) {
                $.ajax({
                    method: 'POST',
                    url: window._AVENCY_BASE_actions.AboAdd,
                    data: {
                        node: me.data('node'),
                        frequency: $('#abo-action-frequency option:selected').data('frequency'),
                        __csrfToken: _AVENCY_NSE_csrfToken
                    }
                }).done(function (data) {
                    if (data.success) {
                        createMessage('success', _AVENCY_BASE_translations.documents.abo.subscribedIziToast);
                    } else {
                        createMessage('danger', _AVENCY_BASE_translations.documents.abo.errorIziToast);
                    }
                }).fail(function () {
                    createMessage('danger', _AVENCY_BASE_translations.documents.abo.errorIziToast);
                }).always(function (data) {
                    updateNotification(data.count);
                    updateText(!!Object.keys(data.subscribed).length);
                    updateClasses(!!Object.keys(data.subscribed).length);
                });
            }
            if (me.hasClass('subscribed')) {
                $.ajax({
                    method: 'POST',
                    url: window._AVENCY_BASE_actions.AboRemove,
                    data: {
                        node: me.data('node'),
                        __csrfToken: _AVENCY_NSE_csrfToken
                    }
                }).done(function (data) {
                    if (data.success) {
                        if (me.data('remove') === true) {
                            me.closest('.row[data-removable]').remove();
                        }
                        createMessage('success', _AVENCY_BASE_translations.documents.abo.unsubscribedIziToast);
                    } else {
                        createMessage('danger', _AVENCY_BASE_translations.documents.abo.errorIziToast);
                    }
                }).fail(function () {
                    createMessage('danger', _AVENCY_BASE_translations.documents.abo.errorIziToast);
                }).always(function (data) {
                    updateNotification(data.count);
                    if (me.data('remove') !== true) {
                        updateText(!!Object.keys(data.subscribed).length);
                        updateClasses(!!Object.keys(data.subscribed).length);
                    }
                });
            }
        });

        $.ajax({
            method: 'POST',
            url: window._AVENCY_BASE_actions.AboGetCount,
            data: {
                __csrfToken: _AVENCY_NSE_csrfToken
            }
        }).done(function (data) {
            updateNotification(data);
        });
    });
})(jQuery, window, document, window.pageLoadedQueue);
